import React, { useEffect, useState } from 'react';
import SVG from 'react-inlinesvg';
import { useDispatch, useSelector } from 'react-redux';

import svgCalendarIcon from '@common/assets/svg/menu/calendar-icon-subscribe.svg';
import svgCalendarIconMobile from '../../assets/svg/objednanie_kruzok.svg';

import Header from '@components/header';
import userInterfaceStore from '@store/user-interface';
import { TRootState } from '@store/root-reducer';
import ProgressBar from '@components/progress-bar';
import { HilbiWidgetViews } from '@store/user-interface/type';

import { LayoutOpenSC, LayoutClosedSC } from './layout.styled';

import {
  AppointmentDate,
  CheckEmail,
  ConfirmEmail,
  FinalRecap,
  InstitutionExpertise,
  OrderRecap,
  Search,
  UserData,
} from '@views/index';

const StepResolver: React.FC = () => {
  const currentStep = useSelector(
    (store: TRootState) => store.userInterface.currentStep,
  );

  switch (currentStep) {
    case HilbiWidgetViews.Search:
      return <Search />;
    case HilbiWidgetViews.InstitutionExpertise:
      return <InstitutionExpertise />;
    case HilbiWidgetViews.AppointmentDate:
      return <AppointmentDate />;
    case HilbiWidgetViews.OrderRecap:
      return <OrderRecap />;
    case HilbiWidgetViews.CheckEmail:
      return <CheckEmail />;
    case HilbiWidgetViews.ConfirmEmail:
      return <ConfirmEmail />;
    case HilbiWidgetViews.UserData:
      return <UserData />;
    case HilbiWidgetViews.Last:
      return <FinalRecap />;
    default:
      return <Search />;
  }
};

const Layout: React.FC = () => {
  const dispatch = useDispatch();
  const widgetOpen: boolean = useSelector(
    (store: TRootState) => store.userInterface.widgetOpen,
  );

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const messageListener = (e: any) => {
      if (e.origin === process.env.REACT_APP_HILBI_LANDING_ORIGIN) {
        setIsMobile(JSON.parse(e.data).isMobile);
      }
    };
    window.addEventListener('message', messageListener);
    return () => {
      window.removeEventListener('message', messageListener);
    };
  }, []);

  if (!widgetOpen) {
    return (
      <LayoutClosedSC
        onClick={() => {
          dispatch(userInterfaceStore.setWidgetOpen({ open: true }));
          window.parent.postMessage('hwwm-open_widget', '*');
        }}
        isMobile={isMobile}
      >
        <SVG src={isMobile ? svgCalendarIconMobile : svgCalendarIcon} />
      </LayoutClosedSC>
    );
  }

  return (
    <LayoutOpenSC>
      <Header />
      <ProgressBar />
      <StepResolver />
    </LayoutOpenSC>
  );
};

export default Layout;
